import Vue from 'vue'
import Vuex from 'vuex'
import navigations from './navigations'
import dictionaries from './dictionaries'
import breadcrumbs from './breadcrumbs'
import bootstrap from './bootstrap'
import group from './lessons/group'
import teacher from './lessons/teacher'
import cabinet from './lessons/cabinet'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    navigations,
    dictionaries,
    breadcrumbs,
    bootstrap,

    lessons: {
      namespaced: true,

      modules: {
        group,
        teacher,
        cabinet
      }
    }
  }
})
